/**
     * @desc 查询状态列表
用于：browse页，查询出所有状态信息列表
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/status/getStatusList', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/status/getStatusList', params);
}
